import { render, staticRenderFns } from "./nineGrid.vue?vue&type=template&id=51b2d254&scoped=true&"
import script from "./nineGrid.vue?vue&type=script&lang=js&"
export * from "./nineGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b2d254",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b2d254')) {
      api.createRecord('51b2d254', component.options)
    } else {
      api.reload('51b2d254', component.options)
    }
    module.hot.accept("./nineGrid.vue?vue&type=template&id=51b2d254&scoped=true&", function () {
      api.rerender('51b2d254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/nine/components/nineGrid.vue"
export default component.exports